import { render, staticRenderFns } from "./myWaterBind.vue?vue&type=template&id=be25a9f8&scoped=true"
import script from "./myWaterBind.vue?vue&type=script&lang=js"
export * from "./myWaterBind.vue?vue&type=script&lang=js"
import style0 from "./myWaterBind.vue?vue&type=style&index=0&id=be25a9f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be25a9f8",
  null
  
)

export default component.exports